// src/services/auditService/auditHkfrsSmeFrsService.ts
import {BASE_AUDIT_API, fetchAPI} from '@/services/api';
import {buildPageQueryParams, ResponsePage} from '@/services/page.interface';

// VO: AuditWpHkfrsSmeFrsVO
export interface SmeFrsVO {
    id?: string;
    pid?: string;
    no?: string;
    content?: string;
    code?: string[];
    isRoot?: number;
    isDel?: number;
    createTime?: string;
    updateTime?: string;
    hasChildren?: boolean;
    children?: SmeFrsVO[];
}

// BO: 新增
export interface SmeFrsCreateBO {
    pid?: string;
    no?: string;
    content?: string;
    code?: string[];
    isRoot?: number;
    isDel?: number;
}

// BO: 更新
export interface SmeFrsUpdateBO {
    id: string;
    pid?: string;
    no?: string;
    content?: string;
    code?: string[];
    isRoot?: number;
    isDel?: number;
}

// 父节点信息 VO
export interface SmeFrsParentInfoVO {
    id?: string;
    no?: string;
    content?: string;
}

// 分页响应结构（core BasePage）
export type SmeFrsPage = ResponsePage<SmeFrsVO>;

const base = `${BASE_AUDIT_API}/hkFrs`;

/** 创建节点 */
export async function create(bo: SmeFrsCreateBO) {
    return fetchAPI<string>(`${base}/create`, {
        method: 'POST',
        body: JSON.stringify(bo),
    });
}

/** 更新节点 */
export async function update(bo: SmeFrsUpdateBO) {
    return fetchAPI<boolean>(`${base}/update`, {
        method: 'PUT',
        body: JSON.stringify(bo),
    });
}

/** 根据ID查询详情 */
export async function getById(id: string) {
    return fetchAPI<SmeFrsVO>(`${base}/getById/${id}`, {
        method: 'GET',
    });
}

/** 逻辑删除 */
export async function deleteById(id: string) {
    return fetchAPI<boolean>(`${base}/deleteById/${id}`, {
        method: 'DELETE',
    });
}

/** 分页查询树列表，支持 content 模糊搜索 */
export async function getTreeList(pageNumber: number, pageSize: number, content?: string) {
    const params = buildPageQueryParams(pageNumber, pageSize);
    if (content) params.set('content', content);
    return fetchAPI<SmeFrsPage>(`${base}/getTreeList?${params.toString()}`, {
        method: 'GET',
    });
}

/** 根据 pid 懒加载直接子节点 */
export async function getChildren(pid: string) {
    return fetchAPI<SmeFrsVO[]>(`${base}/getChildren?pid=${encodeURIComponent(pid)}`, {
        method: 'GET',
    });
}

/** 查询父节点信息列表（用于下拉选择） */
export async function getParentInfoList(id?: string) {
    const params = new URLSearchParams();
    if (id) params.set('id', id);
    const qs = params.toString();
    return fetchAPI<SmeFrsParentInfoVO[]>(`${base}/getParentInfoList${qs ? '?' + qs : ''}`, {
        method: 'GET',
    });
}
